<template>
  <div class="cam-view">
    <div class="cam-view-wrap">
      <FileFrameName v-if="showfilename" @close="closefile" @save="savefile" />
      <CamPlayerArchive ref="video" :camName="camId" :showTimer="true" @screenshot="screenshot">
        <div class="switch-buttons">
          <button class="prev-cam" @click="onCamMove('left')">
            <span class="mdi mdi-chevron-left"></span>
          </button>
          <button class="next-cam" @click="onCamMove('right')">
            <span class="mdi mdi-chevron-right"></span>
          </button>
        </div>
      </CamPlayerArchive>
    </div>
  </div>
</template>

<script>
import { useDefaultStore } from '@/store'
import CamPlayerArchive from '@/components/cam/CamPlayerArchive.vue'
import FileFrameName from '@/components/FileFrameName.vue'
import moment from 'moment'
export default {
  name: 'CamArchiveNew',
  components: {
    CamPlayerArchive,
    FileFrameName
  },
  setup() {
    const store = useDefaultStore()
    return { store }
  },
  computed: {
    videoSrc() {
      const uuid = this.store.currentDivision.guid
      const date = moment(this.date).format('YYYY_MM_D')
      return `//${this.url}/${uuid}/archive/${date}/${this.camId}/index.m3u8`
    },
    aspectRatio() {
      return this.$refs.video.aspectRatio
    }
  },
  data() {
    return {
      fullScreen: false,
      url:
        window.location.protocol == 'http:'
          ? this.store.currentDivision.address
          : this.store.currentDivision.url,
      allowedDays: [],
      range: { startTime: 0, endTime: 84399 },
      camId: this.$route.params.cam ? this.$route.params.cam : null,
      showfilename: false,
      division: this.store.currentDivision
    }
  },
  async mounted() {
    if (this.store.currentDivision)
      this.store.setPageTitle(
        'Архив камеры: ' + this.store.currentDivision.name + ' / ' + this.camId
      )
    // this.dateFromCalendar = this.store.dateSave || moment().format()
  },
  methods: {
    savefile(fileName) {
      const frameUrl = this.screenData
      console.log('frameUrl', frameUrl)
      const link = document.createElement('a')
      link.setAttribute('href', frameUrl)
      link.setAttribute('download', `${fileName}.jpg`)
      link.click()
      this.showfilename = false
    },
    closefile() {
      this.showfilename = false
    },
    screenshot(screenData) {
      this.screenData = screenData
      this.showfilename = true
    },
    onCamMove(direction) {
      console.log(direction);
      if (direction === 'left') {
        let index = this.division.camList.indexOf(this.camId) - 1
        if (index < 0) index = this.division.camList.length - 1
        this.camId = this.division.camList[index]
      }
      if (direction === 'right') {
        let index = this.division.camList.indexOf(this.camId) + 1
        if (index >= this.division.camList.length) index = 0
        this.camId = this.division.camList[index]
      }
      this.$router.push({ name: 'cam-archive-new', params: { cam: this.camId, division: this.division.guid } })
    },
  }
}
</script>

<style scoped>
.cam-view {
  height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
}
.cam-view-wrap {
  display: flex;
  margin-bottom: 1px;
  background-color: #000;
  justify-content: center;
  aspect-ratio: v-bind(aspectRatio);
  max-height: 100%;
}
.video-wrapper {
  width: 100%;
  height: 80%;
}
.switch-buttons {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.prev-cam,
.next-cam {
  font-size: 24px;
}
</style>
